import {createSlice} from "@reduxjs/toolkit";

const initialDevicesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  deviceTypes: undefined,
  deviceFunctionalCategories: undefined,


  deviceForEdit: undefined,
  roomForEdit: undefined,

  bindingList: [],

  hubList: [],
  deviceConfigurations: [],
  deviceConfigInfoDetails: [],

  lastError: null,


  manufacturers: [],
  hubs: [],
  devicefunctions: [],
  deviceConfigs: [],
  thingdefinitions: [],
  subdevices: [],
  listInstallationLoading: false,
  actionsInstallationLoading: false,
  timeoutError: false,

  discoveryTime: 0,
  discoveredDevices: [],

  replaceableDevices: [],

  rssi: -1,

  error: "",
  errorType: "primary",
  showAlert: false,
};


export const callTypes = {
  list: "list",
  action: "action"
};

export const devicesSlice = createSlice({
  name: "devices",
  initialState: initialDevicesState,
  reducers: {


    catchInstallationError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;

      if (action.payload.error.message.startsWith("timeout of "))
        state.timeoutError = true;
      else
        state.timeoutError = false;

      if (action.payload.callType === callTypes.list) {
        state.listInstallationLoading = false;
      } else {
        state.actionsInstallationLoading = false;
      }
    },

    startDiscoveryScan: (state, action) => {
      state.error = null;
      state.timeoutError = false;
      if (action.payload.callType === callTypes.list) {
        state.listInstallationLoading = true;
      } else {
        state.actionsInstallationLoading = true;
      }
    },

    startInstallationCall: (state, action) => {
      state.error = null;
      state.timeoutError = false;
      if (action.payload.callType === callTypes.list) {
        state.listInstallationLoading = true;
      } else {
        state.actionsInstallationLoading = true;
      }
    },

    deviceInfoUpdated: (state, action) => {
      const { data } = action.payload;
      state.entities = state.entities.map(e => {
        if (e.id === data.id) {
          return data;
        }
        return e;
      })
      state.error = "Successfully update device information";
      state.errorType = "success";
      state.showAlert = true;
      state.timeoutError = false;
      state.actionsLoading = false;
    },
    deviceConfigUpdated: (state, action) => {
      const { data } = action.payload;
      state.entities = state.entities.map(e => {
        if (e.id === data.id) {
          return data;
        }
        return e;
      })
      state.error = "Successfully update device config";
      state.errorType = "success";
      state.showAlert = true;
      state.timeoutError = false;
      state.actionsLoading = false;
    },

    deviceFunctionUpdated: (state, action) => {
      const { data } = action.payload;
      // console.log(`DeviceFunction updated ${JSON.stringify(action.payload)}`);
      state.devicefunctions = state.devicefunctions.map(e => {
        if (e.id === data.id) {
          return data;
        }
        return e;
      })
      state.error = "Successfully update device function information";
      state.errorType = "success";
      state.showAlert = true;
      state.timeoutError = false;
      state.actionsLoading = false;
    },

    deviceDeleted: (state, action) => {
      // const { data } = action.payload;
      state.entities = state.entities.filter(e => e.id !== action.payload.deviceId);
      state.error = "Successfully delete device information";
      state.errorType = "info";
      state.showAlert = true;
      state.timeoutError = false;
      state.actionsLoading = false;
    },

    manufecturersFetched: (state, action) => {
      const { data } = action.payload;
      state.listInstallationLoading = false;
      state.error = null;
      state.manufacturers = data;
    },

    // get Hub List
    hubsFetched: (state, action) => {
      state.listInstallationLoading = false;
      state.hubs = action.payload.hubs;
      state.error = null;
    },

    deviceFunctionsFetched: (state, action) => {
      state.listInstallationLoading = false;
      state.devicefunctions = action.payload.devicefunctions;
      state.error = null;
    },
    deviceConfigsFetched: (state, action) => {
      state.listInstallationLoading = false;
      state.deviceConfigs = action.payload.deviceConfigs;
      state.error = null;
    },
    // get tmp discovered devices
    tmpDiscoveredDevicesFetched: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.timeout = false;
      state.discoveredDevices = data;
    },

    // get Hub List
    subDevicesFetched: (state, action) => {
      state.listLoading = false;
      state.subdevices = action.payload.data;
      state.discoveredDevices = [...(action.payload.data).map(d => ({ ...d, id: d.tempDeviceId })), ...state.discoveredDevices];
      state.error = 'Pairing completed. Please check the inbox.';
      state.errorType = 'success';
      state.showAlert = true;
      state.timeoutError = false;
    },

    // get Hub List
    thingDefinitionsFetched: (state, action) => {
      state.listInstallationLoading = false;
      state.thingdefinitions = action.payload.data;
      state.error = null;
      state.timeoutError = false;
    },

    // approve temp device
    approveTempDevice: (state, action) => {
      state.actionsInstallationLoading = false;
      state.thingdefinitions = [];
      state.subdevices = [];
      state.hubs = [];
      state.manufacturers = [];
      state.discoveredDevices = state.discoveredDevices.filter(d => d.id !== action.payload.tmpId);
      state.error = "Successfully added device";
      state.errorType = "success";
      state.showAlert = true;
      state.timeoutError = false;
    },

    replaceSmartMeterDevice: (state, action) => {
      state.actionsInstallationLoading = false;
      state.thingdefinitions = [];
      state.subdevices = [];
      state.hubs = [];
      state.manufacturers = [];
      state.discoveredDevices = state.discoveredDevices.filter(d => d.id !== action.payload.tmpId);
      state.error = "Successfully replace device";
      state.errorType = "success";
      state.showAlert = true;
      state.timeoutError = false;
    },

    fetchAllReplaceableDevice: (state, action) => {
      const { data } = action.payload;
      state.replaceableDevices = data;
      state.listLoading = false;
      state.error = null;
      state.timeout = false;
    },

    // findDevices
    alldevicesFetched: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.timeout = false;
      state.entities = data;
      state.totalCount = data.legnth;
    },


    callSuccess: (state, action) => {
      state.error = "Request successfully";
      state.errorType = "success";
      state.showAlert = true;
      state.timeoutError = false;
    },

    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      state.errorType = "danger";
      state.muiErrorType = "error";
      state.showAlert = true;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      state.showAlert = false;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    hideError: (state, action) => {
      state.error = null;
      state.errorType = '';
      state.showAlert = false;
    },

    // get Room Types
    deviceTypesFetched: (state, action) => {
      state.actionsLoading = false;
      state.deviceTypes = action.payload.deviceTypes;
      state.error = null;
    },

    // get Room Types
    deviceFunCategoriesFetched: (state, action) => {
      state.actionsLoading = false;
      state.deviceFunctionalCategories = action.payload.deviceFunctionalCategories;
      state.error = null;
    },

    // getDeviceById
    deviceFetched: (state, action) => {
      state.actionsLoading = false;
      state.deviceForEdit = action.payload.device;
      state.error = null;
    },


    // Get All Bindings
    allBindingsFetched: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.bindingList = data;
    },




    thingConfigsFetched: (state, action) => {
      const { data } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.deviceConfigurations = data;
    },

    deviceRssiFetched: (state, action) => {
      const { data } = action.payload;
      return {
        ...state,
        rssi: data.fromrssi
      };
    },

    clearRssi: (state) => {
      return {
        ...state,
        rssi: -1
      };
    },

    deviceConfigInfoDetailsFetched: (state, action) => {
      state.error = null;
      state.deviceConfigInfoDetails = [...action.payload.deviceConfigInfoDetails];
    },

    clearDeviceConfigInfoDetailsFetched: (state, action) => {
      state.error = null;
      state.deviceConfigInfoDetails = [];
    }
  }
});
